import { defineStore } from "pinia";
import { ref } from "vue";
import { createDropdownOptionsModule } from "./modules/dropdownOptionsModule.ts";
import { createHeaderBadgesModule } from "./modules/headerBadgesModule.ts";
import { createIntermediateOrderResultsModule } from "./modules/intermediateOrderResultsModule.ts";
import { createSearchFiltersModule } from "./modules/searchFiltersModule.ts";
import { createSearchResultsModule } from "./modules/searchResultsModule.ts";

export const useAppStore = defineStore("app", () => {
  const initialized = ref(false);
  const headerTitle = ref("PO Redistribution");

  // Compose modules
  const searchFilters = createSearchFiltersModule();
  const dropdownOptions = createDropdownOptionsModule();
  const searchResults = createSearchResultsModule();
  const headerBadges = createHeaderBadgesModule(searchFilters, dropdownOptions);
  const intermediateOrderResults = createIntermediateOrderResultsModule();

  function setTitle(value: string): void {
    headerTitle.value = value;
  }

  function markInitialized(): void {
    initialized.value = true;
  }

  function clearSearchParameters(): void {
    searchFilters.clearSearchParameters();
    searchResults.clearSearchResults();
  }

  return {
    // Core
    initialized,
    headerTitle,
    setTitle,
    markInitialized,

    // Search filters from module
    ...searchFilters,
    clearSearchParameters,

    // Header badges from module
    ...headerBadges,

    // Dropdown options from module
    ...dropdownOptions,

    // Search results from module
    ...searchResults,

    // Intermediate Order search results from module
    ...intermediateOrderResults,

    // Backwards compat clearing
    clearSelections: () => {
      headerBadges.clearSelections();
      searchFilters.clearSearchParameters();
      searchResults.clearSearchResults();
    },
  };
});
